// import excerpts from '../components/excerpts';
import childmenu from '../components/childmenu';
import offences from '../components/offences';
import anchormenu from '../components/anchormenu';
import explanatory from '../components/explanatorymenu';
import mobiletables from '../components/mobiletables';

import calculator from '../components/calculator';
import drinkDrive from '../components/drink-drive';
// import modernizr from '../components/modernizr';
// import mlpushmenu from '../components/mlpushmenu';
import mobilemenu from '../components/mobilemenu';

export default {
  init() {
    // JavaScript to be fired on all pages

    // excerpts.init();
    childmenu.init();
    offences.init();
    anchormenu.init();
    calculator.init();
    drinkDrive.init();
    mobilemenu.init();
    explanatory.init();
    mobiletables.init();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // var winHeight = (document.body.scrollHeight + 80);
    // document.body.style.height = winHeight + 'px';

    var pageFooter = document.getElementsByClassName("footer")[0];
    pageFooter.style.display = "block";
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js